<template>
  <div class="page">
    <van-image
        class="bj"
      fit="cover"
      :src="bgUrl"
    />
    <img class="btn" :src="btnUrl" alt="" @click="openApplet" />
  </div>
</template>

<script>
import { getDownloadBannerCotti,getWeChatScheme } from "../../api";
export default {
  data() {
    return {
      bgUrl: "",
      btnUrl: "",
      appletUrl:""
    };
  },
  created() {
    this.$sensors.track("goApplet_page_view");


    console.log(this.$route.query);

    // 背景广告位
    getDownloadBannerCotti({
      code: this.$route.query.bg,
    }).then((res) => {
      console.log(res);
      this.bgUrl = res.data[0].url;
      document.title = res.data[0].subTitle1 ? res.data[0].subTitle1 : "";
    });
    // 按钮广告位
    getDownloadBannerCotti({
      code: this.$route.query.btn,
    }).then((res) => {
      console.log(res);
      this.btnUrl = res.data[0].url;
      this.appletUrl = res.data[0].redirectUrl
    });
  },
  methods: {
    openApplet() {
      this.$sensors.track("goApplet_btn_click");
      const path = this.appletUrl.split('?')[0]
      const query = this.appletUrl.split('?')[1]
      getWeChatScheme({path,query}).then(res=>{
        console.log(res);
        location.href = res.data.scheme;
      })
      
    },
  },
};
</script>

<style lang="scss" scoped>
.page {
  position: relative;
  width: 100%;
  height: 100%;
  .bj {
    width: 100%;
    height: 100vh;
    display: block;
  }
  .btn {
    position: absolute;
    width: 100%;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
  }
}
</style>